function fCurrency(money) {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  })

  return formatter.format(Number(money))
}

const Bundle = {
  products: {},
  settings: {
    gifts_on_one_time: false,
  },
  Defaults: {
    getWidget: function () {
      return $("#subscription-toggle")
    },
    getOneTimeBarWrapper: () => {
      return $(".bundle-progress-bar__wrapper.one-time")
    },
    getSubBarWrapper: () => {
      return $(".bundle-progress-bar__wrapper.subscription")
    },
    getBundleDetailsDiv: function () {
      return Bundle.Defaults.getBundleDiv().find(".bundle-details")
    },
    getAddToCartDiv: function () {
      return $("#bundle-add-to-cart")
    },
    getSubBar: () => {
      return Bundle.Defaults.getSubBarWrapper().find(".bundle-progress-bar")
    },
    getOneTimeBar: () => {
      return Bundle.Defaults.getOneTimeBarWrapper().find(".bundle-progress-bar")
    },
    priceRulesForOneTime: function (bundle_price) {
      const sub_total = bundle_price
      const $gifts = $(".bundle-progress-bar__wrapper.one-time").find(".bundle-progress-bar__item[data-get-at]")

      let stepIndex = Bundle.Utils.getGiftStepIndex($gifts, sub_total)

      const $gift = $gifts[stepIndex > 0 ? stepIndex - 1 : 0]
      const giftString = $gift.getAttribute("data-gift-name")

      let discountObject = [
        { freeAt: 100, amount: 10 },
        { freeAt: 150, amount: 15 },
        { freeAt: 175, amount: 20 },
        { freeAt: 200, amount: 25 },
      ]

      let discount = 0
      if (giftString.indexOf("OFF") >= 0) {
        const giftValue = giftString.replace("% OFF", "")
        discount = Number(giftValue)
      }

      const finalPrice = bundle_price - (bundle_price * discount) / 100
      const compare_at_price = bundle_price

      let save = 0

      if (discount > 0) {
        save = (bundle_price * discount - bundle_price) / 100
      }

      if (finalPrice < compare_at_price) {
        $(".bundle-price").html(
          `${Bundle.Utils.currencyFormat(finalPrice)}<span class="compare_at">$${Bundle.Utils.formatToMoney(
            compare_at_price
          )}</span>`
        )
      } else {
        $(".bundle-price").html(`${Bundle.Utils.currencyFormat(finalPrice)}`)
      }

      if (save > 0) {
        $(".save-amount-container").removeClass("hidden")
      } else {
        $(".save-amount-container").addClass("hidden")
      }

      $("[d-vbsave]").html(`${Bundle.Utils.currencyFormat(save)} (${giftString})`)

      Bundle.Utils.updateIncentiveBar($gifts.length, stepIndex, finalPrice)
      Bundle.Utils.updateIncentiveText(finalPrice, $gifts, stepIndex)
      if (Bundle.settings.gifts_on_one_time) {
        Bundle.Utils.unlockFreeGifts(finalPrice)
      }
    },
    priceRulesForSubscription: function (bundle_price) {
      const finalPrice = Bundle.Utils.formatToMoney(bundle_price - bundle_price * 0.15)
      const compare_at = Bundle.Utils.formatToMoney(bundle_price)

      if (bundle_price > 0) {
        $(".save-amount-container").removeClass("hidden")
        $(".bundle-price").html(
          `${Bundle.Utils.currencyFormat(finalPrice)}<span class="compare_at">$${compare_at}</span>`
        )
      } else {
        $(".save-amount-container").addClass("hidden")
        $(".bundle-price").html(`${Bundle.Utils.currencyFormat(finalPrice)}`)
      }

      const save = compare_at - finalPrice

      if (save > 0) {
        $(".save-amount__label").removeClass("hidden")
        $("[d-vbsave]").html(`${Bundle.Utils.currencyFormat(save)} (15% OFF)`)
      }

      // RENDER gift label
      const $gifts = Bundle.Defaults.getSubBarWrapper().find(".bundle-progress-bar__item[data-get-at]")
      let stepIndex = Bundle.Utils.getGiftStepIndex($gifts, finalPrice)

      Bundle.Utils.updateIncentiveBar($gifts.length, stepIndex, finalPrice)
      Bundle.Utils.updateIncentiveText(finalPrice, $gifts, stepIndex)
      Bundle.Utils.unlockFreeGifts(finalPrice)
    },
  },
  Utils: {
    getBundleSettings: function () {
      const data = JSON.parse(document.getElementById("bundleProductsData").textContent)
      return data.settings
    },
    getBundleItems: function () {
      const data = JSON.parse(document.getElementById("bundleProductsData").textContent)
      return data.products
    },
    generateGuid: function () {
      let d = new Date().getTime()
      let d2 = (performance && performance.now && performance.now() * 1000) || 0
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        let r = Math.random() * 16
        if (d > 0) {
          r = (d + r) % 16 | 0
          d = Math.floor(d / 16)
        } else {
          r = (d2 + r) % 16 | 0
          d2 = Math.floor(d2 / 16)
        }
        return (c === "x" ? r : (r & 0x7) | 0x8).toString(16)
      })
    },
    isSubscription: function () {
      const $widget = Bundle.Defaults.getWidget()
      return $widget.is(":checked")
    },
    calculateBundleQuantity: function () {
      let bundleQty = 0
      const $bundleItems = document.querySelector(".bundle-item")
      $bundleItems.forEach((item) => {
        bundleQty += Number($(this).attr("data-qty"))
      })
      return bundleQty
    },
    calculateSubPrice: function () {
      const bundleProducts = Bundle.Utils.getBundleItems()
      const bundle = Bundle.products
      let price = 0

      Object.entries(bundle).forEach(([key, value]) => {
        const item = bundleProducts.find((obj) => obj.id === Number(key))
        price += item.price * value
      })

      return price
    },
    getGiftStepIndex: function ($gifts, total) {
      let stepIndex = 0
      $gifts.each(function () {
        const freeAt = Number($(this).attr("data-get-at"))
        if (total > freeAt) {
          stepIndex++
        }
      })
      return stepIndex
    },
    currencyFormat: function (num) {
      const price = new Intl.NumberFormat("en-us", {
        style: "currency",
        currency: "USD",
      })
      return price.format(num)
    },
    formatToMoney: function (num) {
      return Number((Math.round(num * 100) / 100).toFixed(2))
    },
    toggleIncentiveBar: function () {
      const $oneTime = Bundle.Defaults.getOneTimeBarWrapper()
      const $sub = Bundle.Defaults.getSubBarWrapper()

      const isSub = Bundle.Utils.isSubscription()

      $(".subscription-label.sub-only").toggleClass("active", isSub)
      $(".subscription-label.one-time").toggleClass("active", !isSub)
      $(".save-15-label").toggleClass("hidden", !isSub)

      if (isSub) {
        $oneTime.addClass("hidden")
        $sub.removeClass("hidden")
        $(".bundle-item__price").addClass("hidden")
        $(".bundle-item__sub-price").removeClass("hidden")
      } else {
        $oneTime.removeClass("hidden")
        $sub.addClass("hidden")
        $(".bundle-item__price").removeClass("hidden")
        $(".bundle-item__sub-price").addClass("hidden")
      }

      Bundle.Utils.updatePrice()
      Bundle.Utils.unlockFreeGifts()
      Bundle.Utils.initializeFreebiesUI()
    },
    handleItemDecrease: function ($item) {
      const bundle = Bundle.products
      const id = Number($item.attr("data-variant-id"))

      const currentValue = bundle[id]

      if (currentValue > 0) bundle[id] = currentValue - 1

      Bundle.Utils.updateItem()
    },
    handleItemIncrease: function ($item) {
      const bundle = Bundle.products
      const id = Number($item.attr("data-variant-id"))

      const currentValue = bundle[id]
      bundle[id] = currentValue ? currentValue + 1 : 1

      Bundle.Utils.updateItem()
    },
    removeItem: function ($item) {
      $item.hide().fadeOut(400)
      const id = Number($item.attr("data-variant-id"))

      const bundle = Bundle.products
      bundle[id] = 0

      Bundle.Utils.updateItem()
    },
    updateItem: function () {
      const bundle = Bundle.products

      Object.entries(bundle).forEach(([key, value]) => {
        const $item = $(`.bundle-item[data-variant-id="${key}"]`)

        const is_disabled = value <= 0

        if ($item) {
          $item.find(".bundle-item__controller").toggleClass("hidden", is_disabled)
          $item.find(".bundle-item__add").toggleClass("hidden", !is_disabled)
          $item.find(".bundle-item__qty-display").html(value)
        }

        if (is_disabled) {
          delete bundle[key]
        }
      })

      if (Object.keys(bundle).length > 0) {
        $("button[data-vbundlebtn]").removeAttr("disabled")
      } else {
        $("button[data-vbundlebtn]").attr("disabled", "disabled")
      }

      Bundle.UI.addedProducts()
    },
    updatePrice: function () {
      const $is_sub = Bundle.Utils.isSubscription()

      const sub_price = Bundle.Utils.calculateSubPrice()

      if ($is_sub) {
        Bundle.Defaults.priceRulesForSubscription(sub_price)
      } else {
        Bundle.Defaults.priceRulesForOneTime(sub_price)
      }
    },
    updateIncentiveText: function (total, $gifts, stepIndex) {
      const $incentive = $(".bundle-incentive-gift__label")
      if (stepIndex < $gifts.length) {
        const $nextFree = $gifts[stepIndex]
        const difference = Bundle.Utils.currencyFormat(Number($nextFree.getAttribute("data-get-at")) - total)
        $incentive.html(`Add ${difference} for ${$nextFree.getAttribute("data-gift-name")}`)
      } else {
        $incentive.html(`Unlocked everything, checkout now!`)
      }
    },
    updateIncentiveBar: function (length, stepIndex, price) {
      const $bar = Bundle.Utils.isSubscription() ? Bundle.Defaults.getSubBar() : Bundle.Defaults.getOneTimeBar()

      if (stepIndex === 0) {
        const total = price || Bundle.Utils.calculateSubPrice()
        total > 0 && $bar.width(`${((total / 75) * 100) / length / 2}%`)
      } else {
        $bar.width(`${(stepIndex * 100) / length}%`)
      }
    },
    unlockFreeGifts: function (price) {
      const total = price || Bundle.Utils.calculateSubPrice()
      const is_sub = Bundle.Utils.isSubscription()

      const handleFreeGifts = () => {
        $(".freebie-card").each(function () {
          const freeAt = $(this).attr("data-free-at")
          if (freeAt <= total) {
            $(this).addClass("unlocked")
          } else {
            $(this).removeClass("unlocked")
          }
        })
      }

      if (is_sub) {
        handleFreeGifts()
      } else {
        if (Bundle.settings.gifts_on_one_time) {
          handleFreeGifts()
        } else {
          $(".freebie-card").removeClass("unlocked")
        }
      }
    },
    initializeFreebiesUI: function () {
      const is_sub = Bundle.Utils.isSubscription()

      if (!Bundle.settings.gifts_on_one_time && !is_sub) {
        $(".free-items__wrapper").hide()
        $(".freebie-list").hide()
        $(".freebie-title").hide()
        $(".mobile-bundle-title").addClass("my-2")

        if ($(window).width() > 750) {
          $("[data-ui-ot-no-gift]").hide()
          $("[data-ui-ot-gift-visible]").show()
        }
      } else {
        $(".free-items__wrapper").show()
        $(".freebie-list").show()
        $(".freebie-title").show()
        $(".mobile-bundle-title").removeClass("my-2")
        $("[data-ui-ot-no-gift]").show()
        $("[data-ui-ot-gift-visible]").hide()
      }
    },
  },
  UI: {
    addedProducts: function () {
      const bundleProducts = Bundle.Utils.getBundleItems()
      const bundle = Bundle.products

      const $added_list_container = $(".added-products-list")
      $added_list_container.empty()

      const emptyBox = `
                <div class="col-xs-4 col-md-3 col-lg-2">
                    <div class="free-product-card__wrapper">
                        <div class="free-product-card">
                            <div class="free-product-card__content">
                                <div class="image is-square"></div>
                            </div>
                        </div>
                    </div>
                </div>
            `

      let count = 0

      Object.entries(bundle).forEach(([key, value]) => {
        if (value > 0) {
          const item = bundleProducts.find((obj) => obj.id === Number(key))
          const itemThumbnail = `
                <div class="col-xs-4 col-md-3 col-lg-2 bundle-thumbnail-item" 
                    data-variant-id="${item.id}"
                    data-qty="${value}"
                    data-selling-plan-id="${item.selling_plan_id}"
                >
                    <div class="free-product-card__wrapper">
                        <div class="free-product-card is-square">
                            <bundle-remove class="free-product-card__icon remove-icon-button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" height="48" width="48">
                                    <path d="M24 26.1 13.5 36.6Q13.05 37.05 12.45 37.05Q11.85 37.05 11.4 36.6Q10.95 36.15 10.95 35.55Q10.95 34.95 11.4 34.5L21.9 24L11.4 13.5Q10.95 13.05 10.95 12.45Q10.95 11.85 11.4 11.4Q11.85 10.95 12.45 10.95Q13.05 10.95 13.5 11.4L24 21.9L34.5 11.4Q34.95 10.95 35.55 10.95Q36.15 10.95 36.6 11.4Q37.05 11.85 37.05 12.45Q37.05 13.05 36.6 13.5L26.1 24L36.6 34.5Q37.05 34.95 37.05 35.55Q37.05 36.15 36.6 36.6Q36.15 37.05 35.55 37.05Q34.95 37.05 34.5 36.6Z"/>
                                </svg>
                            </bundle-remove>
                            <div class="free-product-card__content">
                                <div class="image is-square">
                                    <img src="${item.image}" alt="${item.imageAlt}">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                `

          $added_list_container.append(itemThumbnail)
          count += 1
        }
      })

      if (count === 0) {
        $(".bundle-center-text").show()
      } else {
        $(".bundle-center-text").hide()
      }

      const remainder = 6 - count
      for (let i = 1; i <= remainder; i++) {
        $added_list_container.append(emptyBox)
      }

      Bundle.Utils.updatePrice()
    },
  },
  Constraints: {
    isBundleLessThanMax: function (new_qty) {
      return new_qty <= 12
    },
  },
  Cart: {
    processAddToCart: function () {
      const $bundle = $(".added-products-list")
      let items = Bundle.Cart.generateCart($bundle)

      if (items.length > 0) {
        Bundle.Cart.processToCart(items)
      } else {
        console.log("No items available to add to cart.")
      }
    },
    generateCart: function ($bundle) {
      let cart = []
      const is_subscription = Bundle.Utils.isSubscription()
      const total = Bundle.Utils.calculateSubPrice()

      $bundle.find(".bundle-thumbnail-item").each(function () {
        const qty = Number($(this).attr("data-qty"))
        if (qty > 0) {
          const variant_id = $(this).attr("data-variant-id")
          const item = {
            id: variant_id,
            quantity: qty,
          }
          if (is_subscription && $(this).attr("data-selling-plan-id")) {
            item["selling_plan"] = Number($(this).attr("data-selling-plan-id"))
          }
          cart.push(item)
        }
      })

      //FREEBIE
      const is_sub = Bundle.Utils.isSubscription()
      const allow_freebies = Bundle.settings.gifts_on_one_time

      if (!is_sub && !allow_freebies) return cart

      $(".freebie-card.unlocked").each(function () {
        const variant_id = $(this).attr("data-variant-id")
        const threshold = Number($(this).attr("data-free-at"))
        const item = {
          id: variant_id,
          quantity: 1,
        }
        if (total >= threshold && cart.filter((el) => el.id === item.id).length === 0) {
          cart.push(item)
        }
      })
      return cart
    },
    generateDiscount: function () {
      const total = Bundle.Utils.calculateSubPrice()
      const discounts = [
        { discount: "BUNDLEBUILDER10", at: 100 },
        { discount: "BUNDLEBUILDER15", at: 150 },
        { discount: "BUNDLEBUILDER20", at: 175 },
        { discount: "BUNDLEBUILDER25", at: 200 },
      ]

      let discount = ""

      discounts.forEach((item) => {
        if (item.at <= total) {
          discount = item.discount
        }
      })

      return discount
    },
    processToCart: function (items) {
      console.log(items)

      const discount = Bundle.Cart.generateDiscount()

      const discount_url = Bundle.Utils.isSubscription() ? "" : `?discount=${discount}`

      let formData = {
        items: items,
      }

      fetch("/cart/clear.js", { method: "POST" })
        .then((res) => {
          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
            body: JSON.stringify(formData),
            credentials: "same-origin",
          })
            .then((res) => {
              window.location.href = `/checkout` + discount_url
            })
            .catch((error) => {
              console.log("There was an error adding bundle")
              console.error(error)
            })
        })
        .catch((error) => {
          console.log("FORM NOT CLEARED")
        })
    },
  },
  init: function () {
    const settings = Bundle.Utils.getBundleSettings()
    Bundle.settings = Object.assign(Bundle.settings, settings)

    // Registers the page's Add to Cart button
    $("body").on("click", "button[data-vbundlebtn]", function () {
      event.preventDefault()
      $(this).addClass("loading")
      $(this).attr("disabled", "disabled")
      Bundle.Cart.processAddToCart()
    })

    // Registers function to handle price change when user changes subscription vs one-time
    $("body").on("change", "#subscription-toggle", function () {
      Bundle.Utils.toggleIncentiveBar()
    })
    // Registers each grid item's plus button
    $("body").on("click", ".bundle-item__add", function () {
      const $item = $(this).closest(".bundle-item")
      Bundle.Utils.handleItemIncrease($item, 1)
    })
    // Registers each grid item's plus button
    $("body").on("click", ".bundle-item__qty-controller.plus", function () {
      const item = $(this).closest(".bundle-item")
      Bundle.Utils.handleItemIncrease(item, 1)
    })

    $("body").on("click", ".bundle-item__qty-controller.minus", function () {
      const item = $(this).closest(".bundle-item")
      Bundle.Utils.handleItemDecrease(item, -1)
    })
  },
}

Bundle.init()

class BundleRemove extends HTMLElement {
  constructor() {
    super()
    this.addEventListener("click", this.handleClick.bind(this))
  }

  handleClick() {
    const $item = $(this).closest(".bundle-thumbnail-item")
    Bundle.Utils.removeItem($item)
  }
}

customElements.define("bundle-remove", BundleRemove)

$(window).scroll(function () {
  const $main = $(".collection-bundle-sticky")
  const $spacer = $(".collection-sticky-spacer")
  const mainHeight = $main.height()
  const $elementScrollTOP = $(".collection-bundle-container").position()

  $spacer.height(mainHeight)

  if ($(this).scrollTop() > $elementScrollTOP.top + 200) {
    $main.addClass("fixed")
    $spacer.addClass("visible")
  } else {
    $main.removeClass("fixed")
    $spacer.removeClass("visible")
  }
})

$(document).ready(function () {
  $("#view-bundle").click(function () {
    $(".added-products-modal").fadeIn(400)
    $(".added-products-modal__overlay").fadeIn(500)
  })

  $("#modal-close, .added-products-modal__overlay").click(function () {
    $(".added-products-modal").fadeOut(400)
    $(".added-products-modal__overlay").fadeOut(400)
  })

  $(".product-info-modal__close, .product-info-modal__overlay").click(function () {
    $(".product-info-modal").fadeOut(400)
    $(".product-info-modal__overlay").fadeOut(400)
  })
})

$(window).on("resize", function () {
  const win = $(this) //this = window
  if (win.width() >= 1280) {
    $(".added-products-modal").show()
    $(".added-products-modal__overlay").hide()
  }
})
